export const pt_BR_map = {
  pt_BR: 'br'
};

export function getReactLocale(locale) {
  return pt_BR_map[locale] || locale;
}



/** WEBPACK FOOTER **
 ** ./src/actions/i18nActions/helpers.js
 **/